/**
 * 		Requires: Zurb Foundation 6
 * 		Uses:
 * 			Awesome-Buttons: https://github.com/joshmedeski/foundation-font-awesome-buttons
 */

/*globals $ */

const fnotify = {
  /**
   * From the idea like window.alert, says something and has one button
   *
   * Example:
   * fnotify.alert("Title", "My beautiful question", "Got it!",function(){ alert("Confirmed"); },"large");
   *
   * @param {string} title - Title of the box
   * @param {string} boxtext - Text of the box, normally what you want to say
   * @param {string} buttonlabel - Optional button label
   * @param {function} callback() - Optional callback-function
   * @param {sizing} sizing - Optional sizing of the box, defaults to "tiny". See Foundation 6 Reveal docs for possible options: http://foundation.zurb.com/sites/docs/reveal.html#sizing
   * @param {string} description - Optionale Beschreibung
   */
  alert: function (title, boxtext, buttonlabel, callback, sizing, description) {
    if (!buttonlabel) {
      buttonlabel = "OK";
    }

    if (!sizing) {
      sizing = "tiny";
    }

    if (!description) {
      description = "";
    }

    let clickedButton = function (button) {
      if (button === "success") {
        if (callback) {
          window.setTimeout(function () {
            callback("success");
          }, 500);
        }
      }
    };

    $("#fnotifyReveal")
      // Titel-Text einfügen
      .find(".fnotify-title")
      .html(title)
      .end()
      // Frage-Text einfügen
      .find(".fnotify-text")
      .html(boxtext)
      .end()
      // Verstecke und leere Textarea
      .find(".fnotify-textarea")
      .removeAttr("style")
      .addClass("hide")
      .val("")
      .end()
      // Event auf Button, Button-Text einfügen
      .find(".fnotify-fullbutton")
      .html(buttonlabel)
      .removeClass("hide")
      .off("click")
      .on("click", function () {
        clickedButton("success");
      })
      .end()
      // Verstecke 2er-Buttons
      .find(".fnotify-button.success")
      .addClass("hide")
      .end()
      // Verstecke 2er-Buttons
      .find(".fnotify-button.alert")
      .addClass("hide")
      .end()
      // Grösse festlegen
      .removeClass("tiny small large")
      .addClass(sizing)
      // Beschreibung festlegen
      .data("description", description)
      // Reveal öffnen
      .foundation("open");

    $(document).on("keyup.fnotify", function (e) {
      // answer with key
      if (e.keyCode === 13) {
        // Enter
        clickedButton("success");
        $("#fnotifyReveal").foundation("close");
      }
    });
  },
  /**
   * From the idea like window.confirm, asks something and has two buttons
   *
   * Example:
   * fnotify.confirm(function(button){ alert(button+" pressed"); }, "Title", "My beautiful question", { success: "Yes", alert: "No"}, "large");'
   *
   * @param {function} callback(string) - Callback-function:
   * 		{string} contains which button got clicked – "ok" or "alert";
   * @param {string} title - Title of the box
   * @param {string} question - Text of the box, normally a question
   * @param {object} buttonlabel - Optional button labels
   * @param {string} buttonlabel.success - Label of success-Button (1st)
   * @param {string} buttonlabel.alert - Label of alert-Button (2nd)
   * @param {sizing} sizing - Optional sizing of the box, defaults to "tiny". See Foundation 6 Reveal docs for possible options: http://foundation.zurb.com/sites/docs/reveal.html#sizing
   * @param {string} description - Optionale Beschreibung
   */
  confirm: function (
    callback,
    title,
    question,
    buttonlabel,
    sizing,
    description
  ) {
    if (!buttonlabel) {
      buttonlabel = {};
      buttonlabel.success = "OK";
      buttonlabel.alert = "Abbrechen";
    } else if (!buttonlabel.success) {
      buttonlabel.success = "OK";
    } else if (!buttonlabel.alert) {
      buttonlabel.alert = "Abbrechen";
    }

    if (!sizing) {
      sizing = "tiny";
    }

    if (!description) {
      description = "";
    }

    let clickedButton = function (button) {
      if (button === "success") {
        if (callback) {
          window.setTimeout(function () {
            callback("success");
          }, 500);
        }
      } else if (button === "alert") {
        if (callback) {
          window.setTimeout(function () {
            callback("alert");
          }, 500);
        }
      }
    };

    $("#fnotifyReveal")
      // Titel-Text einfügen
      .find(".fnotify-title")
      .html(title)
      .end()
      // Frage-Text einfügen
      .find(".fnotify-text")
      .html(question)
      .end()
      // Verstecke und leere Textarea
      .find(".fnotify-textarea")
      .removeAttr("style")
      .addClass("hide")
      .val("")
      .end()
      // Verstecke Full-Button
      .find(".fnotify-fullbutton")
      .addClass("hide")
      .end()
      // Event auf Success-Button, Button-Text einfügen
      .find(".fnotify-button.success")
      .html(buttonlabel.success)
      .removeClass("hide")
      .off("click")
      .on("click", function () {
        clickedButton("success");
      })
      .end()
      // Event auf Alert-Button, Button-Text einfügen
      .find(".fnotify-button.alert")
      .html(buttonlabel.alert)
      .removeClass("hide")
      .off("click")
      .on("click", function () {
        clickedButton("alert");
      })
      .end()
      // Grösse festlegen
      .removeClass("tiny small large")
      .addClass(sizing)
      // Beschreibung festlegen
      .data("description", description)
      // Reveal öffnen
      .foundation("open");

    $(document).on("keyup.fnotify", function (e) {
      // answer with key
      if (e.keyCode === 13) {
        // Enter
        clickedButton("success");
        $("#fnotifyReveal").foundation("close");
      }
      if (e.keyCode === 27) {
        // Esc
        clickedButton("alert");
        $("#fnotifyReveal").foundation("close");
      }
    });
  },
  /**
   * From the idea like window.prompt, asks for entering text and has two buttons
   *
   * Example:
   * fnotify.prompt(function(button,answer){alert(button+" pressed: "+answer);}, "Title", "My beautiful question",{ success: "Yes", alert: "No"}, "Placeholder Text", "");
   *
   * @param {function} callback(string, string) - Callback-function:
   * 		{string} contains which button got clicked – "ok" or "alert";
   * 		{string} contains the value of the textarea, "" when "alert" pressed
   * @param {string} title - Title of the box
   * @param {string} question - Text of the box, normally a question
   * @param {object} buttonlabel - Optional button labels
   * @param {string} buttonlabel.success - Label of success-Button (1st)
   * @param {string} buttonlabel.alert - Label of alert-Button (2nd)
   * @param {string} placeholder - Optional placeholder-text of the textarea
   * @param {sizing} sizing - Optional sizing of the box, defaults to "tiny". See Foundation 6 Reveal docs for possible options: http://foundation.zurb.com/sites/docs/reveal.html#sizing
   * @param {boolean} string_only - Makes the textarea one row only
   * @param {string} description - Optionale Beschreibung
   */
  prompt: function (
    callback,
    title,
    question,
    buttonlabel,
    placeholder,
    sizing,
    string_only,
    description
  ) {
    if (!buttonlabel) {
      buttonlabel = {};
      buttonlabel.success = "OK";
      buttonlabel.alert = "Abbrechen";
    } else if (!buttonlabel.success) {
      buttonlabel.success = "OK";
    } else if (!buttonlabel.alert) {
      buttonlabel.alert = "Abbrechen";
    }

    if (!sizing) {
      sizing = "tiny";
    }

    let style = {},
      rows;
    if (string_only) {
      rows = 1;
      style = {
        overflow: "auto",
        resize: "none",
        "min-height": "auto"
      };
    }

    if (!description) {
      description = "";
    }

    let clickedButton = function (button) {
      if (button === "success") {
        let enteredText = $("#fnotifyReveal").find(".fnotify-textarea").val();
        if (callback) {
          window.setTimeout(function () {
            callback("success", enteredText);
          }, 500);
        }
      } else if (button === "alert") {
        if (callback) {
          window.setTimeout(function () {
            callback("alert");
          }, 500);
        }
      }
    };

    $("#fnotifyReveal")
      // Titel-Text einfügen
      .find(".fnotify-title")
      .html(title)
      .end()
      // Frage-Text einfügen
      .find(".fnotify-text")
      .html(question)
      .end()
      // Zeige und leere Textarea
      .find(".fnotify-textarea")
      .removeClass("hide glow")
      .removeAttr("style")
      .val("")
      .prop("placeholder", placeholder)
      .css(style)
      .prop("rows", rows)
      .end()
      // Verstecke Full-Button
      .find(".fnotify-fullbutton")
      .addClass("hide")
      .end()
      // Event auf Success-Button, Button-Text einfügen
      .find(".fnotify-button.success")
      .html(buttonlabel.success)
      .removeClass("hide")
      .off("click")
      .on("click", function () {
        clickedButton("success");
      })
      .end()
      // Event auf Alert-Button, Button-Text einfügen
      .find(".fnotify-button.alert")
      .html(buttonlabel.alert)
      .removeClass("hide")
      .off("click")
      .on("click", function () {
        clickedButton("alert");
      })
      .end()
      // Grösse festlegen
      .removeClass("tiny small large")
      .addClass(sizing)
      // Beschreibung festlegen
      .data("description", description)
      // Reveal öffnen
      .foundation("open");

    $(document).on("keyup.fnotify", function (e) {
      // answer with key
      if (e.keyCode === 13 && $(".fnotify-textarea").is(":focus") === false) {
        // Enter
        clickedButton("success");
        $("#fnotifyReveal").foundation("close");
      }
      if (e.keyCode === 27) {
        // Esc
        clickedButton("alert");
        $("#fnotifyReveal").foundation("close");
      }
    });
  },
  /**
   * On Load of the Plugin, creatis the DOM-Node and appends it to HTML's body
   */
  load: function () {
    let fnotifyReveal = $(
      '<div id="fnotifyReveal" class="reveal [ tiny ] fast row" data-reveal data-animation-in="scale-in-up" data-animation-out="scale-out-down" data-close-on-click="false" data-close-on-esc="false"></div>'
    );

    let fnotifyTextContainer = $(
      '<div class="small-12 columns" style="margin-bottom: 1rem;"></div>'
    )
      .append($('<h2 class="fnotify-title"></h2>'))
      .append($('<p class="fnotify-text" for="fnotifyTextarea"></p>'))
      .append(
        $(
          '<textarea id="fnotifyTextarea" class="fnotify-textarea" autofocus="true" contenteditable="true" rows="4" cols="80" placeholder=""></textarea>'
        )
      );
    fnotifyTextContainer.appendTo(fnotifyReveal);

    let fnotifyButtonFullwidth = $(
      '<div class="small-12 columns"><a data-close class="fnotify-fullbutton [ button success expanded ] [ ffab before fa-check ]"></a></div>'
    );
    fnotifyButtonFullwidth.appendTo(fnotifyReveal);

    let fnotifyButtonSuccess = $(
      '<div class="small-6 columns"><a data-close class="fnotify-button [ button success expanded ] [ ffab after fa-check ]"></a></div>'
    );
    fnotifyButtonSuccess.appendTo(fnotifyReveal);

    let fnotifyButtonAlert = $(
      '<div class="small-6 columns"><a data-close class="fnotify-button [ button alert expanded ] [ ffab after fa-times ]"></a></div>'
    );
    fnotifyButtonAlert.appendTo(fnotifyReveal);

    $("body").append(fnotifyReveal);

    // CSS für glow-Klasse einfügen
    $("head").append(
      "<style type='text/css'>#fnotifyTextarea.glow{-webkit-box-shadow: inset 0px 0px 10px #22bb5b;	-moz-box-shadow: inset 0px 0px 10px #22bb5b;box-shadow: inset 0px 0px 10px #22bb5b;}</style>"
    );

    // FileDrop auf #fnotifyTextarea legen
    // Wenn drag'n'drop in textarea Rand einfärben
    $("#fnotifyTextarea").on("dragenter", function () {
      $(this).addClass("glow");
    });
    $("#fnotifyTextarea").on("dragleave", function () {
      $(this).removeClass("glow");
    });
    $("#fnotifyTextarea").on("dragover", function (e) {
      e.preventDefault();
    });
    // Reagieren auf Datei-Upload und in textarea schreiben
    $("#fnotifyTextarea").on("drop", function (e) {
      // Prevent default behavior (Prevent file from being opened)
      e.preventDefault();
      async function processFile(file) {
        let text;
        if (app.getExtension(file.name) !== "json") {
          text =
            "Datei-Erweiterung nicht akzeptiert: " +
            app.getExtension(file.name);
          console.log("FileDrop: " + text);
          alert(text);
          return true;
        }
        if (
          file.name.search(app.data.settings.key_in_use_private.value) === -1
        ) {
          let richtigeDatei = confirm(
            "Der Dateiname enhält «" +
              app.data.settings.key_in_use_private.value +
              "» nicht. Ist das die richtige Datei?"
          );
          if (richtigeDatei == false) {
            return true;
          }
        }
        if (file.size > 10000) {
          // maximal 19kb einfügen
          text = "Datei ist zu gross: " + file.size + "bytes";
          console.log("FileDrop: " + text);
          alert(text);
          return true;
        }
        let fileContent = await file.text();
        $("#fnotifyTextarea").val(fileContent).removeClass("glow");
      }

      if (e.originalEvent.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        [...e.originalEvent.dataTransfer.items].forEach(async (item) => {
          // If dropped items aren't files, reject them
          if (item.kind === "file") {
            const file = item.getAsFile();
            processFile(file);
          }
        });
      } else {
        // Use DataTransfer interface to access the file(s)
        [...e.originalEvent.dataTransfer.files].forEach((file) => {
          processFile(file);
        });
      }
    });
  }
};

export { fnotify };

// Load it if jQuery is ready
(function ($) {
  fnotify.load();

  // document-Event-Handler entfernen wenn Reveal geschlossen
  $("#fnotifyReveal").on("closed.zf.reveal", function () {
    $(document).off("keyup.fnotify");
  });
})(jQuery);
